export const projectData = {
  name: "Rainbow Life",
  location: "Rainbow Life, Kharghar Sec - 37",

  bannerImg: [
    "/Images/BANNER/1.jpg",
    "/Images/BANNER/2.jpg",
    "/Images/BANNER/3.jpg",
  ],

  overview: `Experience premium living at Ellora Siddhi Rainbow Life, an upscale residential
   tower in Kharghar offering luxurious 2, 3, 4 & 5 BHK apartments. These Vaastu compliant homes 
   are thoughtfully designed with spacious layouts, abundant natural light and excellent 
   ventilation. The project features 40 plus modern lifestyle amenities including an infinity 
   pool, rooftop sky lounge, landscaped gardens, gymnasium and a mini theatre. Residents can enjoy 
   seamless connectivity to Kharghar Railway Station, Mumbai Pune Expressway and the 
   upcoming Navi Mumbai International Airport. Located close to reputed schools, hospitals, 
   malls and Central Park, it ensures everyday convenience. Discover a perfect blend of 
   luxury, comfort and connectivity at Ellora Siddhi Rainbow Life.`,

  highlights: [
    "An Iconic 36 Storey Tower",
    "Premium Location of Kharghar",
    "Well Vebtilated Apartment",
    "Lake View Apartments",
    "6 Levels Podium Parking",
    "3 Levels of Exclusive Amenities",
  ],

  configurations: [
    { type: "2 BHK", area: 698, price: "₹ 1.23 Cr* ++" },
    { type: "2 BHK", area: 737, price: "₹ 1.29 Cr* ++" },
    { type: "3 BHK", area: 928, price: "₹ 1.67 Cr* ++" },
    { type: "3 BHK", area: 952, price: "₹ 1.71 Cr* ++" },
  ],

  floorPlan: [
    "/Images/FLOOR PLAN/3BHK.jpg",
    "/Images/FLOOR PLAN/4BHK.jpg",
  ],

  amenities: [
    { title: "Swimming Pool", img: "/Images/AMENITIES/1.jpg" },
    { title: "Indoor Games", img: "/Images/AMENITIES/3.jpg" },
    { title: "Kids Play Area", img: "/Images/AMENITIES/4.jpg" },
    { title: "Podium Parking", img: "/Images/AMENITIES/5.jpg" },
    { title: "Senior Citizen Area", img: "/Images/AMENITIES/6.jpg" },
  ],
  gallary: [
    "/Images/GALLERY/1.jpg",
    "/Images/GALLERY/2.jpg",
    "/Images/GALLERY/3.jpg",
    "/Images/GALLERY/4.jpg",
    "/Images/AMENITIES/2.jpg"
  ],

  connectivityData: [
    {
      title: "Connectivity",
      items: [
        "Amandooth Metro Station – 02 Min",
        "Kharghar Railway Station – 15 Min",
        "Sion-Panvel Highway – 10 Min",
        "Navi Mumbai International Airport – 30 Min",
      ],
    },
    {
      title: "Education Hub",
      items: [
        "Vibgyor High School - 08 Min",
        "Cambridge Preschool – 10 Min",
        "Global International School and Junior College - 10 Min",
        "Rainbow International School - 15 Min",
      ],
    },
    {
      title: "Healthcare",
      items: [
        "Tata Hospital – 05 Min",
        "D.Y. Patil Hospital – 30 Min",
      ],
    },
    {
      title: "Malls / Shopping",
      items: [
        "Central Park & Golf Course – 05 Min",
        "Little World – 10 Min",
        "Nexus Seawoods Mall – 30 Min",
      ],
    },
  ],
};
